import axios from 'axios';
import { attachAuthInterceptor } from './authInterceptor';
import { API_BASE_URL } from '../utils/constants';
import { getAuthToken } from '../utils/storage';
import { extractApiError } from '../utils/apiError';
import { applyWarehouseFilter, warehouseParamsSerializer } from '../utils/warehouseParams';

const challanAnalyticsAPI = axios.create({
    baseURL: `${API_BASE_URL}/api/v1/challan-analytics`,
    headers: { 'Content-Type': 'application/json' },
    paramsSerializer: warehouseParamsSerializer,
});

// Session-expiry handling (401 -> clear + redirect), consistent with feature services.
attachAuthInterceptor(challanAnalyticsAPI);

challanAnalyticsAPI.interceptors.request.use(
    (config) => {
        const token = getAuthToken();
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return applyWarehouseFilter(config);
    },
    (error) => Promise.reject(error)
);

const challanAnalyticsService = {
    async getSummary(params = {}) {
        try {
            const response = await challanAnalyticsAPI.get('/summary', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: extractApiError(error) };
        }
    },

    async getProducts(params = {}, options = {}) {
        try {
            const response = await challanAnalyticsAPI.get('/products', { params, ...options });
            return { success: true, data: response.data };
        } catch (error) {
            if (axios.isCancel(error)) {
                return { success: false, error: 'Request canceled', isCanceled: true };
            }
            return { success: false, error: extractApiError(error) };
        }
    },

    async getCustomers(params = {}, options = {}) {
        try {
            const response = await challanAnalyticsAPI.get('/customers', { params, ...options });
            return { success: true, data: response.data };
        } catch (error) {
            if (axios.isCancel(error)) {
                return { success: false, error: 'Request canceled', isCanceled: true };
            }
            return { success: false, error: extractApiError(error) };
        }
    },

    async getDaily(params = {}, options = {}) {
        try {
            const response = await challanAnalyticsAPI.get('/daily', { params, ...options });
            return { success: true, data: response.data };
        } catch (error) {
            if (axios.isCancel(error)) {
                return { success: false, error: 'Request canceled', isCanceled: true };
            }
            return { success: false, error: extractApiError(error) };
        }
    },

    async getList(params = {}, options = {}) {
        try {
            const response = await challanAnalyticsAPI.get('/list', { params, ...options });
            return { success: true, data: response.data };
        } catch (error) {
            if (axios.isCancel(error)) {
                return { success: false, error: 'Request canceled', isCanceled: true };
            }
            return { success: false, error: extractApiError(error) };
        }
    },
};

export default challanAnalyticsService;
